import { Box, Drawer, DrawerProps, styled } from '@mui/material';
import { forwardRef } from 'react';

export const BottomSheetModalDrawer = styled(
  forwardRef<HTMLDivElement, DrawerProps>((props, ref) => (
    <Drawer ref={ref} slotProps={{}} {...props} />
  )),
)(({ theme }) => ({
  '&.MuiDrawer-modal': {
    zIndex: theme.zIndex.modal,

    '.MuiDrawer-paper': {
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
      zIndex: theme.zIndex.modal,
    },
  },
}));

export const BottomSheetModalContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  width: '100%',

  '.MuiButton-root': {
    display: 'block',
    margin: `0 auto`,
  },
}));
